// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_46-2";
export var blackBorderOnHover = "_46-7";
export var cell = "_46-6";
export var cellContainer = "_46-3";
export var checked = "_46-8";
export var disabled = "_46-5";
export var featuredIconCellContainer = "_46-9";
export var featuredIconTextContainer = "_46-b";
export var featuredIconWrapper = "_46-a";
export var noBorder = "_46-c";
export var orangeSelectedRow = "_c4-3";
export var overflowableText = "_46-0";
export var overflowableTextContainer = "_46-1";
export var row = "_49-0";
export var rowCheckboxCell = "_46-4";
export var selectableTable = "_c4-2";